window.addEventListener("load", () => {
  document.querySelectorAll(".hideBeforeAdimationLoaded").forEach((element) => {
    element.classList.remove("hideBeforeAdimationLoaded");
  });
});
if (document.querySelector("main#home")) {
  import("./home.js").catch((error) => {
    console.error("Error loading home.js:", error);
  });
}
if (document.querySelector("main#page-about")) {
  import("./about.js").catch((error) => {
    console.error("Error loading about.js:", error);
  });
}

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// CTA
gsap.from("#request .request-title", {
  scrollTrigger: {
    trigger: "#request",
    start: "top 80%",
  },
  y: 20,
  x: -20,
  opacity: 0,
});
gsap.from("#request .form-title", {
  scrollTrigger: {
    trigger: "#request",
    start: "top 80%",
  },
  y: 20,
  opacity: 0,
});

// News
gsap.from("#news :where(.news-main-title, .news-text p)", {
  scrollTrigger: {
    trigger: "#news",
    start: "top 80%",
  },
  y: 20,
  x: -20,
  opacity: 0,
  stagger: 0.1,
});
gsap.from("#news .news-list", {
  scrollTrigger: {
    trigger: "#news",
    start: "top 80%",
  },
  y: 20,
  x: -20,
  opacity: 0,
  stagger: 0.1,
});
